


















































import { CollectionNames } from '@/services/meiosis';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IContent } from '../models';
import AddContextCard from './add-context-card.vue';
import EditComponentCard from './edit-component-card.vue';

@Component({
  components: { AddContextCard, EditComponentCard },
})
export default class KanbanCard extends Vue {
  @Prop({ default: () => ({}) }) public item!: Partial<IContent>;
  @Prop({ default: '' }) public itemkey!: CollectionNames;
  @Prop({ default: undefined }) private readonly isIncluded!: boolean;
  private menu = false;
  private editMenu = false;

  constructor() {
    super();
  }

  private hasContext(item: Partial<IContent>): boolean {
    return !!item && !!item.context && !!item.context.type;
  }

  private getContext(item: Partial<IContent>): string {
    if (!item || !item.context || !item.context.type)
      return this.$options.filters && this.$options.filters.capitalize(this.$t('APP.ADD_CONTEXT'));
    return item.context.type;
  }

  private async selectItem() {
    this.item.type && this.item.id && this.$store.actions[this.item.type].load(this.item.id);
  }

  private async deleteItem() {
    this.item.type && this.item.id && this.$store.actions[this.item.type].del(this.item.id);
  }

  private closeMenu() {
    this.menu = false;
  }

  private closeEditMenu() {
    this.editMenu = false;
  }

  mounted(): void {
    return;
  }
}
